/**
 * This type is used to express a multivariate experiment flag.
 * As a general best practice, experiments should contain two variants:
 * - control – the Control variant is the current state of a feature.
 * - test – the Test variant is the _new_ state of the feature that you're building.
 */
const FEATURE_FLAG_DEFAULTS = {
    achHoldsV1: false,
    chatImageAttachmentPreviews: false,
    cmdKMenu: false,
    communityFeedFollowing: false,
    communityFeedRedesign: false,
    communityPersonalization: false,
    contestCreation: false,
    contraProBlackFridayDiscount: false,
    editorRefreshMilestone3: false,
    framerAdExperimentDismissButton: 'control',
    framerAdvertisingUpdates: false,
    indyTransactionLogsV2: false,
    membersOnly: false,
    oneOffPayments: 'control',
    reworkedSaveToListsFlow: false,
};
export const getDefaultFeatureFlags = () => {
    return FEATURE_FLAG_DEFAULTS;
};
//# sourceMappingURL=index.js.map